import { Grid, Header, Segment } from '@mairistem/composants';
import { formatMontant } from '@mairistem/finances-utils';
import React from 'react';

export interface PluriannuelleFooterProps {
	autorisationProgrammeCount?: number;
	autorisationEngagementCount?: number;
	montantTotalPeriode?: number;
	yearCount: number;
}

const PluriannuelleFooter = ({
	autorisationProgrammeCount = 0,
	autorisationEngagementCount = 0,
	montantTotalPeriode = 0,
	yearCount = 0,
}: PluriannuelleFooterProps) => (
	<Segment>
		<Grid>
			<Grid.Row columns={3}>
				<Grid.Column textAlign="center">
					<Header>
						<Header.Content>
							<span className="autorisationProgrammeCount">
								{autorisationProgrammeCount}
							</span>
							<Header.Subheader
								content={`Autorisation${autorisationProgrammeCount > 1 ? 's' : ''} de programme`}
							/>
						</Header.Content>
					</Header>
				</Grid.Column>
				<Grid.Column textAlign="center">
					<Header>
						<Header.Content>
							<span className="autorisationEngagementCount">
								{autorisationEngagementCount}
							</span>
							<Header.Subheader
								content={`Autorisation${autorisationEngagementCount > 1 ? 's' : ''} d'engagement`}
							/>
						</Header.Content>
					</Header>
				</Grid.Column>
				<Grid.Column textAlign="center">
					<Header>
						<Header.Content>
							{formatMontant(montantTotalPeriode)}
							<Header.Subheader>
								Montant total période (Moyenne:{' '}
								{formatMontant(montantTotalPeriode / yearCount)}
								/an)
							</Header.Subheader>
						</Header.Content>
					</Header>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	</Segment>
);

export default PluriannuelleFooter;
